

function removeFirstCharFromInputs(){
  if (document.querySelector(":focus")) {
    var val = ""
    var focused = document.querySelector(":focus");
    if (typeof focused!='object') return false
    if (focused.tagName == "INPUT") {
      if (focused.getAttribute("type") == "text") {
        val = focused.value.substr(0, focused.value.length - 1);
        focused.value = val;
      }
    }else if (focused.tagName == "TEXTAREA") {
        val = focused.value.substr(0, focused.value.length - 1);
        focused.value = val;
    }
  }
}

// Liefert die Endezeichen (Key-Codes) des Keyboard-Wedge-Scanners aus den Einstellungen.
// false = kein Scanner mit Tastatursimulation eingestellt -> onScan.js darf NICHT angehängt werden,
// sonst werden schnelle Tastatureingaben (preventDefault) verschluckt.
function getSuffix(){
  let settings = null
  try {
    const s = localStorage.getItem("settings")
    if (s) settings = JSON.parse(s)
  } catch (e) {
    return false
  }
  if (!settings) return false

  switch(settings.keyboardwedgescanner){
      case "CR":
          return [13];
      case "LF":
          return [10];
      case "CRLF":
          return [10,13];
      case "Tab":
          return [9];
      default:
          return false;
  }
}

export default {
  removeFirstCharFromInputs,
  getSuffix
};